import React, { useState } from 'react';
import Modal from 'react-modal';
import { Button, Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';
import ShowProgress from '../ui/Backdrop';
import 'react-toastify/dist/ReactToastify.css';
import Theme from '../ui/Theme';
import { getGuideTagList, getTagList, showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { ErrorToast, MultipleErrorToast, notifySuccess } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';
const useStyles = makeStyles(() => ({
  resize: {
    backgroundColor: Theme.palette.secondary.main,
    height: '141px',
    width: '343px',
    padding: '5px 10px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '17px',
    lineHeight: '21px',
    marginTop: '9px',
  },
  cancelBtn: {
    width: '163.5px',
    height: '42px',
    marginLeft: '12px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  addBtn: {
    width: '163.5px',
    height: '42px',
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  popupSubHeading: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginTop: 0,
  },

  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
}));

const AddNewTag = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const tagList = useSelector((state) => state.getTagList.taglist);
  const guideTagList = useSelector((state) => state.getGuideTagList.guidetaglist);

  const [viewTagPop, setViewTagPop] = useState(true);
  const [tagTitle, setTagTitle] = useState('');

  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (!tagTitle) {
      formIsValid = false;
      errors.push('Please enter tag title.');
    }
    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return formIsValid;
  };
  const submit = async () => {
    const check = validateForm();
    if (check) {
      dispatch(showProgress(true));
      const data = JSON.stringify({
        title: tagTitle,
        type: props.type,
      });
      await service
        .post(apiEndpoints.JOURNEY_TAGS, data)
        .then((response) => {
          if (props.type === 'journey') {
            tagList.push(response);
            dispatch(getTagList(tagList));
          } else if (props.type === 'guide') {
            guideTagList.push(response);
            dispatch(getGuideTagList(guideTagList));
          }
          dispatch(showProgress(false));
          notifySuccess('Completed Successfully');
          closePopup();
        })
        .catch((error) => {
          dispatch(showProgress(false));
          ErrorToast(error);
          closePopup();
        });
    }
  };
  const handleTagTitleChange = (e) => {
    setTagTitle(e.target.value);
  };
  const closePopup = () => {
    setViewTagPop(false);
    props.close();
  };

  return (
    <Modal
      isOpen={viewTagPop}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
        },
        content: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          border: 0,
          height: '324px',
          width: '375px',
          overflow: 'auto',
        },
      }}
    >
      <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Grid item>
          <Grid container direction="column" justifyContent="space-between" alignItems="flex-start">
            <Grid item className={classes.popupHeading}>
              {props.type === 'journey' ? 'Journey Tag' : 'Guide Tag'}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        style={{ marginTop: '24px' }}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Grid item>
          <TextField
            id="tagTitleId"
            name="tagTitle"
            required
            autoFocus
            autoComplete="off"
            autoSave="off"
            onChange={handleTagTitleChange}
            placeholder={props.type === 'journey' ? 'Enter journey tag here' : 'Enter guide tag here'}
            multiline
            InputProps={{
              disableUnderline: true,
              classes: {
                input: classes.resize,
              },
            }}
            value={tagTitle}
            rows={5}
          />
        </Grid>

        <Grid item>
          <Grid container direction="row" style={{ marginTop: '24px' }}>
            <Grid item>
              <Button onClick={closePopup} variant="contained" disableElevation className={classes.cancelBtn}>
                Cancel
              </Button>
              <Button variant="contained" color="primary" className={classes.addBtn} onClick={() => submit()}>
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ShowProgress />
    </Modal>
  );
};

export default AddNewTag;
